import 'css-chunk:src/index/components/summary_item/summary_item.module.scss';export default {
  "tablet": "tablet__cMH84",
  "sp": "sp__XF47C",
  "pc": "pc__KYWrI",
  "pcTablet": "pcTablet__3Ngrf",
  "section": "section__5JbRt",
  "relative": "relative__7MIok",
  "row": "row__yQGiO",
  "middle": "middle__8R5AY",
  "formLabel": "formLabel__SkhCM",
  "formLabel2": "formLabel2__qOWSF",
  "formLabelIssue": "formLabelIssue__iblIG",
  "item": "item__QVbso",
  "icon": "icon__n9BtZ",
  "title": "title__EtbZV",
  "number": "number__xvTXn",
  "arrow": "arrow__VGzZo"
};